import { RestrictedRoute } from "RestrictedRoute";
import { AppLayout } from "components/AppLayout/AppLayout";
import { AutofillPage } from "components/AutoFill/AutofillPage";
import { BookkeepingTracker } from "components/BooksCrm/BookkeepingTracker";
import { ChatLeftNav } from "components/ChatLeftNav/ChatLeftNav";
import { DeadlinesTracker } from "components/DeadlinesTracker";
import { FilingDeadlinesDashboard } from "components/FilingDeadlinesDashboard/FilingDeadlinesDashboard";
import { GroupPracticeCrm } from "components/PracticeCrm/GroupPracticeCrm";
import { PracticeCrm } from "components/PracticeCrm/PracticeCrm";
import { RoutesAccrossApps } from "components/RoutesAcrossApps/RoutesAcrossApps";
import {
  LeftBar,
  LeftBarItem,
  LeftBarLogo,
  LeftBarSeparator,
} from "components/Sidebar/LeftBar";
import { SubMenu } from "components/Sidebar/SubMenu";
import { KnowledgeBaseNavItem } from "components/Sidebar/KnowledgeBaseNavItem";
import { TeamManagement } from "components/TeamManagement/TeamManagement";
import { TopBar } from "components/TopBar/TopBar";
import { GroupData } from "components/crm/groupData";
import GroupSelect from "components/dashboard/sideBar/groupSelect";
import { PageNotFound } from "components/design/PageNotFound";
import WelcomeUser from "components/design/welcomeUser";
import { Captable } from "components/icons/LeftNav/Board/Captable";
import { Home } from "components/icons/LeftNav/Home";
import { Ticket } from "components/icons/LeftNav/Ticket";
import { InkleTax } from "components/icons/Logos/InkleTax";
import { InkleTaxSymbol } from "components/icons/Logos/InkleTaxSymbol";
import PerksCrm from "components/perksCrm/PerksCrm";
import { SalesCrmRoute } from "components/salesCrm/SalesCrmRoute";
import { ArchivedCrm } from "components/serviceTeam/ArchivedCrm";
import { BooksCRM } from "components/serviceTeam/BooksCrm";
import ServiceTeam from "components/serviceTeam/serviceTeam";
import ConsultantDashboard from "components/tasks/consultantDashboard/consultantDashBoard";
import { ForeignCATask } from "components/tasks/taskForForeignCA/ForeignCATask";
import { FOREIGN_CA } from "constants/onBoarding";
import { useAuth } from "hooks/useAuth";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { Redirect, Switch, useRouteMatch } from "react-router-dom";
import "static/styles/containers/dashboard.css";
import { AuditLogs } from "../AuditLogs/AuditLogs";
import { useCurrentAppContext } from "contexts/CurrentAppContext";
import { useEffect } from "react";
import { RAMailroomSubscriptions } from "components/RAMailroomSubscriptions/RAMailroomSubscriptions";
import { TaskTracker } from "components/icons/LeftNav/Admin/TaskTracker";
import { Sales } from "components/icons/LeftNav/Admin/Sales";
import { Practice } from "components/icons/LeftNav/Admin/Practice";
import { Perks } from "components/icons/Navbar/Perks";
import { Coupon } from "components/icons/LeftNav/Admin/Coupon";
import { Coupons } from "pages/Coupons/Coupons";
import { CouponDetail } from "pages/Coupons/CouponDetail";
import { TeamManagement as TeamManagementIcon } from "components/icons/LeftNav/Admin/TeamManagement";
import { AuditLogs as AuditLogsIcon } from "components/icons/LeftNav/Admin/AuditLogs";
import ParserAI from "./ParserAI";
import { ActivityChart } from "components/icons/ActivityChart";
import { Task1120Tracker } from "pages/Task1120Tracker/Task1120Tracker";
import { SalesTaxTracker } from "pages/SalesTax/SalesTaxTracker/SalesTaxTracker";
import { SupportDashboard } from "pages/SupportDashboard/SupportDashboard";
import { ChaserDashboard } from "pages/ChaserDashboard/ChaserDashboard";
import { ListIcon } from "components/icons/ListIcon";
import { IncorporationTracker } from "pages/Incorporation/IncorporationTracker/IncorporationTracker";
import { IncorporationTemplates } from "pages/Incorporation/IncorporationTemplates/IncorporationTemplates";
import { IncorporationTrackerFormBuilder } from "pages/Incorporation/IncorporationFormEditor/IncorporationTrackerFormBuilder";
import { IncorporationTemplateFormBuilder } from "pages/Incorporation/IncorporationFormEditor/IncorporationTemplateFormBuilder";
import { IncorporationIcon } from "components/icons/IncorporationIcon";

export const AdminNavbar = () => {
  const { type } = useAuth();
  const { isAdmin } = useRoleBasedView();

  return (
    <div className="t-h-full t-flex t-flex-col t-justify-between">
      <div>
        {type === FOREIGN_CA && (
          <div className="t-m-2">
            <GroupSelect />
          </div>
        )}

        <LeftBarItem useParentPath={false} exact to="/admin" icon={Home}>
          Home
        </LeftBarItem>

        <SubMenu.Root
          title="Tasks tracker"
          useParentPath={false}
          defaultRoute="/admin/filings"
          childPaths={[
            "/admin/filings",
            "/admin/myfilings",
            "/admin/bookkeeping-tracker",
            "/admin/task-1120-tracker",
            "/admin/salestax-tracker",
            "/admin/deadlines-tracker",
          ]}
        >
          <SubMenu.Trigger icon={TaskTracker}>Tasks Tracker</SubMenu.Trigger>
          <SubMenu.Container hoverTitle="Tasks tracker">
            <SubMenu.Item useParentPath={false} to="/admin/filings" exact>
              All filings
            </SubMenu.Item>
            {isAdmin && (
              <SubMenu.Item
                useParentPath={false}
                to="/admin/filings-deadlines-dashboard"
              >
                Deadlines
              </SubMenu.Item>
            )}
            <SubMenu.Item useParentPath={false} to="/admin/myfilings">
              My filings
            </SubMenu.Item>
            {isAdmin && (
              <SubMenu.Item
                useParentPath={false}
                to="/admin/bookkeeping-tracker"
              >
                Bookkeeping tracker
              </SubMenu.Item>
            )}
            <SubMenu.Item useParentPath={false} to="/admin/task-1120-tracker">
              1120 tracker
            </SubMenu.Item>
            {isAdmin && (
              <SubMenu.Item useParentPath={false} to="/admin/salestax-tracker">
                Sales tax tracker
              </SubMenu.Item>
            )}
          </SubMenu.Container>
        </SubMenu.Root>

        <SubMenu.Root
          title="Ops CRM"
          useParentPath={false}
          defaultRoute="/admin/crm"
          childPaths={[
            "/admin/crm",
            "/admin/radeadlines",
            "/admin/bookscrm",
            "/admin/archivedcrm",
          ]}
          excludePaths={["/admin/crm/"]}
        >
          <SubMenu.Trigger icon={Captable}>Ops</SubMenu.Trigger>
          <SubMenu.Container hoverTitle="Ops CRM">
            <SubMenu.Item useParentPath={false} to="/admin/crm" exact>
              All Clients
            </SubMenu.Item>
            <SubMenu.Item useParentPath={false} to="/admin/radeadlines">
              Reg Agents
            </SubMenu.Item>
            <SubMenu.Item useParentPath={false} to="/admin/bookscrm">
              Books CRM
            </SubMenu.Item>
            <SubMenu.Item useParentPath={false} to="/admin/archivedcrm">
              Archived
            </SubMenu.Item>
          </SubMenu.Container>
        </SubMenu.Root>

        {isAdmin && (
          <>
            <SubMenu.Root
              title="Sales CRM"
              useParentPath={false}
              defaultRoute="/admin/salescrm"
              childPaths={["/admin/salescrm"]}
            >
              <SubMenu.Trigger icon={Sales}>Sales</SubMenu.Trigger>
              <SubMenu.Container hoverTitle="Sales CRM">
                <SubMenu.Item useParentPath={false} to="/admin/salescrm" exact>
                  Groups
                </SubMenu.Item>
                <SubMenu.Item
                  useParentPath={false}
                  to="/admin/salescrm/profiles"
                >
                  Profiles
                </SubMenu.Item>
                <SubMenu.Item
                  useParentPath={false}
                  to="/admin/salescrm/archived"
                >
                  Archived
                </SubMenu.Item>
              </SubMenu.Container>
            </SubMenu.Root>
            <SubMenu.Root
              title="Incorporation"
              useParentPath={false}
              defaultRoute="/admin/incorporation/tracker"
              childPaths={["/admin/incorporation"]}
            >
              <SubMenu.Trigger icon={IncorporationIcon}>
                Incorporation
              </SubMenu.Trigger>
              <SubMenu.Container hoverTitle="Incorporation">
                <SubMenu.Item
                  useParentPath={false}
                  to="/admin/incorporation/tracker"
                >
                  Tracker
                </SubMenu.Item>
                <SubMenu.Item
                  useParentPath={false}
                  to="/admin/incorporation/templates"
                >
                  Templates
                </SubMenu.Item>
              </SubMenu.Container>
            </SubMenu.Root>
            <LeftBarItem
              useParentPath={false}
              to="/admin/practicecrm"
              icon={Practice}
            >
              Practice
            </LeftBarItem>
            <LeftBarItem
              useParentPath={false}
              to="/admin/perkscrm"
              icon={Perks}
            >
              Perks
            </LeftBarItem>

            <LeftBarItem
              useParentPath={false}
              to="/admin/coupons"
              icon={Coupon}
            >
              Coupons
            </LeftBarItem>
            <LeftBarItem
              useParentPath={false}
              to="/admin/chaser-dashboard"
              icon={ActivityChart}
            >
              Chaser Items
            </LeftBarItem>
          </>
        )}
        <LeftBarItem
          useParentPath={false}
          to="/admin/teammanagement"
          icon={TeamManagementIcon}
        >
          Team Management
        </LeftBarItem>
        {isAdmin && (
          <LeftBarItem
            useParentPath={false}
            to="/admin/support-dashboard"
            icon={TaskTracker}
          >
            Support Dashboard
          </LeftBarItem>
        )}
      </div>
    </div>
  );
};

export const AdminStickyNav = () => (
  <>
    <LeftBarItem useParentPath={false} to="/admin/tickets" icon={Ticket}>
      Tickets
    </LeftBarItem>
    <ChatLeftNav
      useParentPath={false}
      to="/admin/chat/unreplied"
      collapseOnClick
    />
    <KnowledgeBaseNavItem />
  </>
);

export const AdminDashboard = () => {
  const { path, url } = useRouteMatch();
  const { isAdmin, isCpa } = useRoleBasedView();
  const { dispatch: currentAppDispatch } = useCurrentAppContext();

  useEffect(() => {
    currentAppDispatch({
      type: "SET_CURRENT_APP",
      payload: { currentApp: "Tax Admin" },
    });
  }, [currentAppDispatch]);

  return (
    <AppLayout
      sidebar={
        <LeftBar
          logo={<LeftBarLogo logo={InkleTax} symbol={InkleTaxSymbol} />}
          showCollapse
          stickyNav={<AdminStickyNav />}
        >
          <AdminNavbar />
        </LeftBar>
      }
      topbar={
        <TopBar
          logo={<LeftBarLogo logo={InkleTax} symbol={InkleTaxSymbol} />}
          nav={<AdminNavbar />}
          stickyNav={<AdminStickyNav />}
        />
      }
      // banner={
      //   <DashboardBanner
      //     isCustomer={isCustomer!}
      //     subscriptionInactive={subscriptionInactive}
      //     stripePromise={stripePromise}
      //   />
      // }
    >
      <Switch>
        <RestrictedRoute
          path={`${path}/auditlog`}
          component={isAdmin ? AuditLogs : PageNotFound}
        />
        <RestrictedRoute
          exact
          path={`${path}/crm/:groupId/autofills/addresses`}
          render={() => <AutofillPage type="addresses" />}
        />
        <RestrictedRoute
          exact
          path={`${path}/crm/:groupId/autofills/bank_accounts`}
          render={() => <AutofillPage type="bank_accounts" />}
        />
        <RestrictedRoute
          exact
          path={`${path}/crm/:groupId/autofills/authorized_persons`}
          render={() => <AutofillPage type="authorized_persons" />}
        />
        <RestrictedRoute path={`${path}/crm/:groupId`} component={GroupData} />
        <RestrictedRoute path={`${path}/crm`} component={ServiceTeam} />
        <RestrictedRoute
          path={`${path}/salescrm`}
          component={isAdmin ? SalesCrmRoute : PageNotFound}
        />
        <RestrictedRoute
          exact
          path={`${path}/incorporation/tracker`}
          component={isAdmin ? IncorporationTracker : PageNotFound}
        />
        <RestrictedRoute
          exact
          path={`${path}/incorporation/templates`}
          component={isAdmin ? IncorporationTemplates : PageNotFound}
        />
        <RestrictedRoute
          exact
          path={`${path}/incorporation/tracker/:formInstanceId`}
          component={isAdmin ? IncorporationTrackerFormBuilder : PageNotFound}
        />
        <RestrictedRoute
          exact
          path={`${path}/incorporation/templates/:templateId`}
          component={isAdmin ? IncorporationTemplateFormBuilder : PageNotFound}
        />
        <RestrictedRoute exact path={`${path}/incorporation`}>
          <Redirect to={`${path}/incorporation/tracker`} />
        </RestrictedRoute>
        <RestrictedRoute
          path={`${path}/practicecrm/:practicecrmId`}
          component={isAdmin ? GroupPracticeCrm : PageNotFound}
        />
        <RestrictedRoute
          path={`${path}/practicecrm`}
          component={isAdmin ? PracticeCrm : PageNotFound}
        />
        <RestrictedRoute
          exact
          path={`${path}/perkscrm`}
          component={isAdmin ? PerksCrm : PageNotFound}
        />
        <RestrictedRoute path={`${path}/filings`} component={ForeignCATask} />
        <RestrictedRoute
          exact
          path={`${path}/coupons`}
          component={isAdmin ? Coupons : PageNotFound}
        />
        <RestrictedRoute
          exact
          path={`${path}/coupons/:couponId`}
          component={isAdmin ? CouponDetail : PageNotFound}
        />
        <RestrictedRoute
          exact
          path={`${path}/myfilings`}
          component={ConsultantDashboard}
        />
        <RestrictedRoute
          exact
          path={`${path}/deadlines-tracker`}
          component={DeadlinesTracker}
        />
        <RestrictedRoute
          exact
          path={`${path}/filings-deadlines-dashboard`}
          component={isAdmin ? FilingDeadlinesDashboard : PageNotFound}
        />

        <RestrictedRoute exact path="/mytasks">
          <Redirect to={`${path}/myfilings`} />
        </RestrictedRoute>

        <RestrictedRoute
          exact
          path={`${path}/bookkeeping-tracker`}
          component={isAdmin ? BookkeepingTracker : PageNotFound}
        />
        <RestrictedRoute
          exact
          path={`${path}/task-1120-tracker`}
          component={Task1120Tracker}
        />
        <RestrictedRoute
          exact
          path={`${path}/salestax-tracker`}
          component={isAdmin ? SalesTaxTracker : PageNotFound}
        />

        <RestrictedRoute
          exact
          path={`${path}/radeadlines`}
          component={RAMailroomSubscriptions}
        />
        <RestrictedRoute exact path={`${path}/bookscrm`} component={BooksCRM} />
        <RestrictedRoute
          exact
          path={`${path}/archivedcrm`}
          component={ArchivedCrm}
        />
        <RestrictedRoute
          path={`${path}/teammanagement`}
          component={TeamManagement}
        />

        <RestrictedRoute path={`${path}/parser`} component={ParserAI} />
        <RestrictedRoute
          exact
          path={`${path}/chaser-dashboard`}
          component={ChaserDashboard}
        />
        <RestrictedRoute
          exact
          path={`${path}/support-dashboard`}
          component={isAdmin ? SupportDashboard : PageNotFound}
        />

        <RestrictedRoute exact path={path} component={WelcomeUser} />
        <RoutesAccrossApps />
      </Switch>
    </AppLayout>
  );
};
